// extracted by mini-css-extract-plugin
export var body = "_l7-0";
export var sectionHeader = "_l7-4";
export var shortcutColumns = "_l7-2";
export var shortcutList = "_l7-1";
export var shortcutSection = "_l7-3";